<template>
    <modal @close="modeResetExperience">
        <template slot="header_title">
            Nouvelle Expérience
        </template>
        <template slot="main">
            <div class="main_new_experience">
                <v-text-field v-model="name" :error-messages="!name ? 'Veuillez saisir un nom': ''" solo>
                    <template v-slot:label>
                        Nom<i class="red--text">*</i>
                    </template>
                </v-text-field>
                <v-textarea v-model="description" solo name="input-7-4" label="Description" />
            </div>
        </template>
        <template slot="footer">
            <v-layout row wrap>
                <v-flex xs2>
                    <v-btn class="custom_btn_position custom_btn_color_red" @click="modeResetExperience">
                        <i class="fas fa-times fa-btn" /><span v-if="!isMobile">Annuler</span>
                    </v-btn>
                </v-flex>
                <v-flex xs2>
                    <v-btn :disabled="validator" class="custom_btn_position custom_btn_color_blue"
                           @click="localAddExperience">
                        <i class="fas fa-check fa-btn" /><span v-if="!isMobile">Valider</span>
                    </v-btn>
                </v-flex>
                <v-flex xs8>
                    <span v-if="validator" class="help is-danger">Veuillez saisir un nom d'expérience</span>
                </v-flex>
            </v-layout>
        </template>
    </modal>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'ModalNewExperience',
        components: {
            modal: () => import('../../global/modal')
        },
        computed: {
            ...mapGetters('experiences', ['experiences']),
            ...mapGetters('app', ['isMobile']),
            name: {
                get () {
                    return this.$store.state.experiences.newExperience.name;
                },
                set (name) {
                    this.$store.commit('experiences/SET_NEW_EXPERIENCE', { name });
                }
            },
            description: {
                get () {
                    return this.$store.state.experiences.newExperience.description;
                },
                set (description) {
                    this.$store.commit('experiences/SET_NEW_EXPERIENCE', { description });
                }
            },
            validator: function () {
                return !this.name;
            }
        },
        methods: {
            ...mapActions('experiences', ['modeResetExperience', 'addExperience']),
            ...mapActions('app', ['showOverlay', 'hideOverlay']),
            localAddExperience: function () {
                this.showOverlay();
                this.addExperience().then((token) => {
                    if (!token) return;
                    this.hideOverlay();
                    this.modeResetExperience();
                    this.$toasted.success('Création de l\'expérience avec succés');
                    this.$router.push({
                        name: 'augmentations',
                        params: { experienceToken: token }
                    });
                }).catch((err) => {
                    this.hideOverlay();
                    this.modeResetExperience();
                    this.$toasted.error('Une erreur est apparu lors de la création de l\'expérience : ' + err);
                });
            }
        }
    };
</script>

<style lang="scss" scoped>

    .main_new_experience {
        padding: 20px;
    }
</style>
